import { useActiveBrandConfig } from './useActiveBrandConfig';

export const useActiveBrand = () => {
  return useActiveBrandConfig().chainCode;
};
